// What the person last clicked, for the "Site error" email (30-oct-2026: the
// email said where they were but not what they pressed). Only a control's own
// label: never what they typed in a field.
const CLICKABLE = 'button, a, [role="button"], summary, input, select, textarea';
const MAX = 80;

const tidy = (s) => String(s || "").replace(/\s+/g, " ").trim().slice(0, MAX);

export const clickLabel = (target) => {
  const el = target && target.closest ? target.closest(CLICKABLE) : null;
  if (!el) return "";
  const named = el.getAttribute("aria-label");
  if (named) return tidy(named);
  const tag = String(el.tagName).toLowerCase();
  if (tag === "input" && ["button", "submit"].includes(el.getAttribute("type"))) return tidy(el.getAttribute("value"));
  if (["input", "select", "textarea"].includes(tag)) {
    return tidy(el.getAttribute("placeholder") || el.getAttribute("name") || el.getAttribute("id") || `a ${tag} field`);
  }
  return tidy(el.innerText || el.textContent);
};

let last = "";

export const lastClick = () => last;

export const trackClicks = () => {
  const onClick = (e) => {
    last = clickLabel(e.target) || last;
  };
  document.addEventListener("click", onClick, true);
  return () => document.removeEventListener("click", onClick, true);
};
